import React, { useState } from "react";
import "../css/returns.scss";
function Returns() {
  const [expandedSection, setExpandedSection] = useState(null);

  const toggleSection = (section) => {
    setExpandedSection(expandedSection === section ? null : section);
  };

  return (
    <div className="wrapper--narrow section-padding">
      <div className="text__standard" data-accordion-group="">
        <p className="standard__kicker text-left accent-size-4">RETURNS</p>

        <div className="accordion__wrapper">
          <button
            className="accordion__title"
            onClick={() => toggleSection("policy")}
          >
            Return policy
            <svg
              className={`accordion-icon ${
                expandedSection === "policy" ? "expanded" : ""
              }`}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>
          {expandedSection === "policy" && (
            <div className="accordion__body rte body-size-4">
              <p>
                If you are not completely satisfied with your purchase we accept
                returns for all unworn, unaltered, unused, full-priced
                merchandise with its original tags and packaging.
              </p>
              <p>
                We accept returns and full refunds on all full-priced items
                within 14 days of delivery. Please be advised all sale items are
                a final sale and returns or exchanges will not be accommodated.
              </p>
              <p>
                Please e-mail us at{" "}
                <a href="mailto:kit@sacuddin.shop" title="kit@sacuddin.shop">
                  kit@sacuddin.shop
                </a>{" "}
                to request a return authorization.
              </p>
            </div>
          )}
        </div>

        <div className="accordion__wrapper">
          <button
            className="accordion__title"
            onClick={() => toggleSection("initiate")}
          >
            Initiate a return
            <svg
              className={`accordion-icon ${
                expandedSection === "initiate" ? "expanded" : ""
              }`}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>
          {expandedSection === "initiate" && (
            <div className="accordion__body rte body-size-4">
              <p>
                To request a return, please e-mail&nbsp;
                <a href="mailto:kit@sacuddin.shop" title="kit@sacuddin.shop">
                  kit@sacuddin.shop
                </a>
                &nbsp;and we will respond with additional instructions.
              </p>
              <p>
                The returns process may take up to 3 weeks to complete. Once we
                can verify that the merchandise has been checked-in and is in
                good condition, we will email a refund confirmation.
              </p>
            </div>
          )}
        </div>

        <div className="accordion__wrapper">
          <button
            className="accordion__title"
            onClick={() => toggleSection("international")}
          >
            International returns
            <svg
              className={`accordion-icon ${
                expandedSection === "international" ? "expanded" : ""
              }`}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>
          {expandedSection === "international" && (
            <div className="accordion__body rte body-size-4">
              <p>
                To request a return, please e-mail{" "}
                <a href="mailto:kit@sacuddin.shop" title="kit@sacuddin.shop">
                  kit@sacuddin.shop
                </a>
                &nbsp;and we will respond with additional instructions. For
                international returns, please ensure that items are returned to
                our warehouse within 30 days of delivery of your original order.
                Once we can verify that the merchandise has been checked-in and
                in good condition, we will email a refund confirmation.
              </p>
            </div>
          )}
        </div>

        <div className="accordion__wrapper">
          <button
            className="accordion__title"
            onClick={() => toggleSection("exchanges")}
          >
            Exchanges
            <svg
              className={`accordion-icon ${
                expandedSection === "exchanges" ? "expanded" : ""
              }`}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>
          {expandedSection === "exchanges" && (
            <div className="accordion__body rte body-size-4">
              <p>
                Sacuddin does not offer formal exchanges at this time. Please
                place an order for the new size/style, and we will process the
                refund when your original purchase is received.
              </p>
            </div>
          )}
        </div>

        <div className="accordion__wrapper">
          <button
            className="accordion__title"
            onClick={() => toggleSection("customs")}
          >
            Customs and Duties
            <svg
              className={`accordion-icon ${
                expandedSection === "customs" ? "expanded" : ""
              }`}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>
          {expandedSection === "customs" && (
            <div className="accordion__body rte body-size-4">
              <p>
                We ship International orders DDU (Duties Delivered Unpaid). Once
                the carrier is in possession of your order, you are responsible
                for any additional taxes and duties. Sacuddin is not responsible
                for any fees charged by customs.
              </p>
              <p>
                In the event you will be returning your order, you will be
                responsible for the original shipping charges, any duties, taxes
                and/or customs charges that are incurred on the package for both
                the original and return shipments. We cannot refund any shipping
                fees on your original purchase.
              </p>
            </div>
          )}
        </div>

        <div className="accordion__wrapper">
          <button
            className="accordion__title"
            onClick={() => toggleSection("taxes")}
          >
            Taxes
            <svg
              className={`accordion-icon ${
                expandedSection === "taxes" ? "expanded" : ""
              }`}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>
          {expandedSection === "taxes" && (
            <div className="accordion__body rte body-size-4">
              <p>
                Please be aware that for domestic orders, we are obligated to
                collect state sales tax in New York and California. This amount
                is calculated at checkout
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Returns;
